import { LANGUAGES } from '../constants/languages'
import { ASSIGNMENT_PROCESSING_STATUSES } from '../constants/assignment-processing-statuses'
import { ASSIGNMENT_TYPES } from '../constants/assignment-types'

export const isExcelAssignment = language => language === LANGUAGES.EXCEL.value
export const isTextAssignment = language => language === LANGUAGES.TEXT.value
export const isNewTextAssignment = language => language === LANGUAGES.NEW_TEXT.value
export const isMba = type => type === ASSIGNMENT_TYPES.MODEL_BOUND_ASSIGNMENT.value
export const isModel = type => type === ASSIGNMENT_TYPES.MODEL.value
export const checkIfAssignmentIsProcessing = status =>
    status !== ASSIGNMENT_PROCESSING_STATUSES.READY && status !== ASSIGNMENT_PROCESSING_STATUSES.ERROR
